import { render, staticRenderFns } from "./UnitsAndRoleDialog.vue?vue&type=template&id=df85a78e&scoped=true"
import script from "./UnitsAndRoleDialog.vue?vue&type=script&lang=js"
export * from "./UnitsAndRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./UnitsAndRoleDialog.vue?vue&type=style&index=0&id=df85a78e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df85a78e",
  null
  
)

export default component.exports